import type { ProviderOffer } from '@features/roomProviders';
import { productTypes } from '@fr/constants';
import { type TProductType } from '@ve/components/serpHotelCard/types';
import { type TouristGroup } from '@ve/types';
import { type IBackboneProduct } from '@ve/types/backboneModels/Domain/ObjectValue';

export default (hotelCardRightBlockDataForProps: {
  product: IBackboneProduct;
  productType: TProductType;
  productPrice: number;
  touristText?: string;
  offers?: ProviderOffer[];
}): {
  touristGroup: TouristGroup;
  checkInDate: string;
  nights: number;
  productPrice: number;
  productType: string;
  tooltipBottomText: string;
  touristText?: string;
  offers?: ProviderOffer[];
} => {
  const getTooltipBottomText = () => {
    switch (hotelCardRightBlockDataForProps.productType) {
      case productTypes.HOTEL_OFFER: {
        return 'В стоимость проживания обычно входит: номер в отеле, питание — по выбору';
      }
      case productTypes.RAILWAY_TOUR: {
        return 'В стоимость тура обычно входит: номер в отеле, питание, Ж/Д билеты, страховка, трансфер — по выбору';
      }
      default: {
        return 'В стоимость тура обычно входит: номер в отеле, питание, перелёты, страховка, трансфер — по выбору';
      }
    }
  };

  return {
    touristGroup: hotelCardRightBlockDataForProps.product.get('touristGroup'),
    checkInDate: hotelCardRightBlockDataForProps.product.get('checkInDate'),
    nights: hotelCardRightBlockDataForProps.product.get('nights'),
    productPrice: hotelCardRightBlockDataForProps.productPrice,
    productType: hotelCardRightBlockDataForProps.productType,
    tooltipBottomText: getTooltipBottomText(),
    touristText: hotelCardRightBlockDataForProps.touristText,
    offers: hotelCardRightBlockDataForProps.offers,
  };
};
